import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/** Base of every feed query key — `[key, segment, type, searchUrl, locale]`. */
export const ACTIVITY_FEED_QUERY_KEY = 'current-user-activity-events';

/**
 * Refetch the activity feed. Invalidating the base key covers every segment/filter variant, so the
 * pane the user is looking at refetches now and the others refetch when next mounted — a status
 * change is not specific to the filter that happened to be active.
 *
 * Unlike `refresh()` (pull-to-refresh) this does not drop back to the first page: loaded pages are
 * refetched in place, so a user who had scrolled keeps their position.
 */
export const useRefetchActivityFeed = (): (() => void) => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [ACTIVITY_FEED_QUERY_KEY] });
  }, [queryClient]);
};
